export default "__VITE_ASSET__968ba005__"